import request from "@/config/utils/request";

//取回密码提交
export function dealSupplierFindPwd(data) {
  return request({
    url: "/apis/scp/smc/dealSupplierFindPwd",
    method: "post",
    data
  });
}
export function checkSuppilerName(data) {
  return request({
    url: "/apis/scp/smc/checkSuppilerName",
    method: "post",
    data
  });
}
//供应商协同公告列表查询
export function listSupBidNotice(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/listSupBidNotice",
    method: "post",
    data
  });
}
//供应商协同公告详情查询
export function qryNoticeDetail(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/qryNoticeDetail",
    // url: "/apis/scp/bidc/users/signup/qryNoticeDetail",
    method: "post",
    data
  });
}

// 查询首页列表数据
export function queryScpSchemeNoticeList(data) {
  return request({
    url: "/apis/scp/bidc/queryScpSchemeNoticeList",
    method: "post",
    data
  });
}

// 查询首页列表数据
export function queryScpSchemeNoticeListByNoLogin(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/queryScpSchemeNoticeListByNoLogin",
    method: "post",
    data
  });
}


//相关公告列表查询
export function qryRelatedNoticeList(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/qryRelatedNoticeList",
    method: "post",
    data
  });
}

//查询包件信息
export function queryProcessSchemeMatDetail(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/queryProcessSchemeMatDetail",
    method: "post",
    data
  });
}

//单位累计金额和项目数量查询
export function qryUnitAmountAndProjectNum(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/qryUnitAmountAndProjectNum",
    method: "post",
    data
  });
}

//查询寻源完成累计金额和项目数量查询
export function qryFinishedAmountAndProjectNum(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/qryFinishedAmountAndProjectNum",
    method: "post",
    data
  });
}

//单位推荐协同公告列表查询
export function listOpUnitBidNotice(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/listOpUnitBidNotice",
    method: "post",
    data
  });
}
/*
//查询相关公告列表
export function qryNoticeList(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryNoticeList",
    method: "post",
    data
  });
}
*/

//通知公告
export function queryPublishedNoticeList(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/noticeInfo/queryPublishedNoticeList",
    method: "post",
    data
  });
}

//通知公告详情
export function queryNoticeById(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/noticeInfo/queryNoticeById",
    method: "post",
    data
  });
}

//宣传海报
export function qryPostersList(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/pubcontent/qryPostersList",
    method: "post",
    data
  });
}

//轮播图点击量统计
export function updateHits(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/pubcontent/updateHits",
    method: "post",
    data
  });
}

// 新增轮播点击记录
export function insertSubconPosterClick(data) {
  return request({
    url: "/apis/scp/SubConPoster/users/signup/insertSubconPosterClick",
    method: "post",
    data
  });
}

// 导购类目
export function getGuideCategoryTreeList(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/guidecate/getGuideCategoryTreeList",
    method: "post",
    data
  });
}

//操作指南
export function queryNoviceGuide(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/cmc/noviceGuide/queryNoviceGuide",
    method: "post",
    data
  });
}

//常见问题列表
export function listFaqProblem(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/hc/faqProblem/listFaqProblem",
    method: "post",
    data
  });
}

//查看常见问题详情
export function getFaqProblemById(data) {
  return request({
    url: "/apis/scp/spcms/users/signup/hc/faqProblem/getFaqProblemById",
    method: "post",
    data
  });
}

// 搜索
export function searchSupBidNotice(data) {
  return request({
    // url: "/apis/scp/bidc/users/signup/searchSupBidNotice",
    // url: "/apis/bid-scp/bidc/searchSupBidNotice",
    url: "/apis/scp/bidc/users/signup/searchSupBidNotice ",
    method: "post",
    data
  });
}

// 查询物资分类
export function qryMatcateryTreeList(data) {
  return request({
    url: "/apis/scp/mtc/users/signup/qryMatcateryTreeList",
    method: "post",
    data
  });
}

//用于供应商校验是否可以参与
export function qrySupJoinCheck(data) {
  return request({
    url: "apis/scp/bidc/qrySupJoinCheck",
    method: "post",
    data
  });
}

//用于查询当前登录人是采购商还是供应商
/*export function qryUserPartCompanyList(data) {
  return request({
    url: "apis/sp/org/qryUserPartCompanyList",
    method: "post",
    data
  });
}*/
//用于字典列表查询
export function listDictByCode(data) {
  return request({
    url: "/apis/scp/common/users/signup/listDictByCode",
    method: "post",
    data
  });
}
export function selectSubjectNewList(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/selectSubjectNewList",
    method: "post",
    data
  });
}


export function encBlackList(data) {
  return request({
    url: "/apis/scp/bidc/encBlackList",
    method: "post",
    data
  });
}

// 获取单位
export function qryOmcOrgTree(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/qryOmcOrgTree",
    method: "post",
    data
  });
}
// 获取工程类别
export function selectFirstLevelSubjectCode(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/selectFirstLevelSubjectCode",
    method: "post",
    data
  });
}
// 获取国家
export function getCountryList(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/getCountryList",
    method: "post",
    data
  });
}
// 获取省
export function getAdministrationList(data) {
  return request({
    url: "/apis/scp/bidc/users/signup/getAdministrationList",
    method: "post",
    data
  });
}
